module.exports = __webpack_public_path__ + "img/animals@2x.84b1156.jpg";